export enum ObsDrawerContentKey {
  IMAGE_TITLE = 'imageTitle',
  PASSENGERS = 'passengers',
  CAR_PARKING_INPUT = 'carParkingInput',
  ADDITIONAL_NOTES_TOOLTIP = 'additionalNotesTooltip',
}
